<template>
  <div class="flex flex-col mt-5">
    <div class="text-center">
      <h2 class="font-medium text-lg md:text-xl lg:text-2xl">Bolão</h2>
    </div>
    <div class="flex-1 flex flex-col items-center py-5">
      <div class="">
        <input
          class="bg-gray-200 w-100 appearance-none border-2 border-gray-200 rounded py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mb-5"
          type="text"
          @input="setResult($event.target)"
          v-model="result"
        />
      </div>
      <table>
        <tr v-for="(numbers, index) in filteredBets" :key="`bet-${index}`">
          <td v-for="(num, ind) in numbers" :key="`bet-${index}-${ind}`">{{num}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Bolao',
  data () {
    return {
      result: '',
      bets: [
        [1,2,3,4,5,6],
        [1,7,10,15,16,33],
        [1,11,33,34,51,55],
        [1,12,14,23,31,42],
        [1,12,28,37,40,43],
        [1,15,30,58,59,60],
        [1,17,47,52,57,60],
        [1,19,25,33,42,45],
        [1,19,31,40,45,47],
        [1,32,41,49,51,59],
        [2,4,18,36,41,52],
        [2,5,14,18,22,27],
        [2,5,14,23,53,57],
        [2,8,16,22,32,42],
        [2,11,27,33,37,43],
        [2,12,27,33,35,57],
        [2,20,23,32,45,47],
        [3,6,26,41,42,49],
        [3,7,9,17,43,54],
        [3,8,20,39,43,47],
        [3,9,12,21,23,31],
        [3,9,18,38,47,49],
        [3,9,18,38,47,49],
        [3,9,36,41,45,48],
        [3,15,27,44,48,59],
        [3,17,31,37,42,53],
        [3,23,26,33,56,60],
        [4,12,13,23,45,55],
        [4,12,25,30,39,57],
        [4,13,17,23,45,55],
        [4,18,23,37,41,48],
        [5,6,7,24,38,56],
        [5,8,12,20,28,56],
        [5,8,13,20,28,56],
        [5,9,11,13,23,49],
        [5,12,19,41,47,53],
        [5,13,17,20,23,45],
        [5,15,16,24,31,44],
        [5,15,21,25,28,33],
        [5,15,22,24,37,53],
        [5,29,32,36,46,48],
        [6,9,25,43,49,57],
        [6,15,19,33,37,49],
        [6,17,22,33,45,46],
        [6,25,29,39,41,48],
        [7,11,18,24,38,56],
        [7,13,17,26,37,58],
        [7,13,27,31,45,52],
        [7,14,17,35,44,48],
        [7,31,40,48,55,59],
        [7,34,43,49,53,57],
        [8,9,14,18,20,48],
        [8,10,11,19,20,25],
        [8,10,11,19,25,54],
        [8,10,11,20,25,54],
        [8,10,13,22,48,54],
        [8,13,20,34,36,41],
        [8,13,25,27,33,47],
        [8,14,17,26,34,47],
        [8,14,23,26,46,50],
        [8,16,28,39,50,55],
        [8,19,20,22,25,26],
        [8,28,35,36,37,49],
        [9,10,12,23,46,57],
        [9,10,17,23,46,57],
        [9,10,21,22,26,54],
        [9,17,21,36,44,57],
        [9,18,24,33,38,60],
        [9,18,24,35,37,55],
        [9,20,40,44,50,57],
        [10,13,21,34,46,59],
        [10,14,24,40,41,46],
        [10,18,25,35,41,54],
        [10,23,25,36,43,58],
        [10,23,26,30,51,59],
        [11,12,20,29,38,54],
        [11,14,21,29,48,49],
        [11,17,22,38,49,57],
        [11,17,24,35,40,57],
        [11,18,19,39,40,53],
        [11,18,19,39,40,53],
        [12,14,15,23,43,52],
        [12,18,28,36,40,51],
        [12,21,30,36,50,55],
        [12,23,24,34,35,51],
        [12,32,35,42,51,53],
        [13,19,27,31,48,49],
        [14,20,23,26,30,55],
        [15,16,25,31,41,43],
        [15,17,19,36,43,59],
        [15,29,31,32,35,38],
        [15,33,42,48,52,54],
        [16,19,24,27,45,55],
        [16,24,34,39,42,48],
        [16,25,31,32,38,46],
        [17,19,28,33,37,44],
        [20,31,39,44,48,53],
        [21,23,31,36,48,59],
        [21,27,29,45,52,55],
        [22,25,26,45,48,55],
        [25,26,33,38,42,53],
        [27,30,32,42,51,58],
        [28,36,42,45,55,59],
        [31,35,39,47,49,50],
        [34,37,40,44,45,54],
      ]
    }
  },
  computed: {
    filteredBets () {
      const result = (this.result || '')
        .split(',')
        .filter(i => !!i)
        .map(i => parseInt(i))
        .filter(i => !isNaN(i))

      if (!result.length)
        return this.bets

      return this.bets.filter(bet => {
        let hits = 0

        for (const num of bet) {
          if (result.includes(num))
            hits++
        }

        return hits > (result.length > 3 ? 3 : (result.length - 1))
      })
    }
  },
  methods: {
    setResult (input) {
      const val = input.value || ''

      const arr = val
                    .replace(/[^0-9,]/g, '')
                    .split(',')
                    .map(i => parseInt(i))
                    .map(i => (isNaN(i) ? '' : (i > 60 ? 60 : i)))

      this.result = arr.join(',')
    }
  },
}
</script>
<style lang="scss" scoped>
  table {
    border: 2px solid;

    tr {
      &:not(:first-child) {
        margin-top: 5px;
        border-top: 2px solid;
      }

      td {
        align: center;
        padding: 10px;

        &:not(:first-child) {
          border-left: 2px solid;
        }
      }
    }
  }
</style>
